// mutations
const SET_MINI = (state, payload) => {
  state.miniNav = payload;
};
const SET_TOKEN_EXPIRED = (state, payload) => {
  state.tokenExpired = payload;
};
const SET_TEMPPASSWORD = (state, payload) => {
  state.temp_password = payload;
};
//role
const SET_RESROLE = (state, payload) => {
  state.res_role = payload;
};
const SET_TEMPROLE = (state, payload) => {
  state.temp_role = payload;
};
const SET_IDROLE = (state, payload) => {
  state.idrole = payload;
};
const SET_RESMENU = (state, payload) => {
  state.res_menu = payload;
};
const SET_RESACCESSLIST = (state, payload) => {
  state.res_accesslist = payload;
};
const SET_ACCESSCRETE = (state, payload) => {
  state.dataCreateAccess = payload;
};
const SET_ACCESSDELETE = (state, payload) => {
  state.dataDeleteAccess = payload;
};
const SET_RESMENUAUTH = (state, payload) => {
  state.res_authMenu = payload;
};
export default {
  SET_MINI,
  SET_TOKEN_EXPIRED,
  SET_TEMPPASSWORD,
  SET_RESROLE,
  SET_TEMPROLE,
  SET_IDROLE,
  SET_RESMENU,
  SET_RESACCESSLIST,
  SET_ACCESSDELETE,
  SET_ACCESSCRETE,
  SET_RESMENUAUTH
};
